import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { clearTickets, getTicketsV2 } from '../../../../actions/index';
import { TICKET_PATH } from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { TICKETS_COLUMNS } from '../../../../config/columns';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

const Tickets = ({
  tickets,
  loading,
  breadcrumbs,
  dispatchGetTicketsV2,
  dispatchClearTickets,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearTickets();
    },
    [],
  );

  const data = tickets.get('content') || [];
  const pages = tickets.get('totalPages') || null;
  const defaultPageSize = tickets.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <>
      <ModuleList
        title="Boletos"
        breadcrumbs={breadcrumbs}
        tableStructure={{
          columns: TICKETS_COLUMNS,
          data,
          pages,
          defaultPageSize,
          filterable: true,
          fetchData: dispatchGetTicketsV2,
          modelPath: TICKET_PATH,
          loading,
          navigateToModelOnRowClick: true,
        }}
      />
    </>
  );
};

const mapStateToProps = ({ ReservationUnit, authentication }) => ({
  breadcrumbs: [
    ...ReservationUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Boletos',
      href: TICKET_PATH,
    },
  ],
  tickets: ReservationUnit.Ticket.getIn(['all', 'content']),
  loading: ReservationUnit.Ticket.getIn(['all', 'loading']),
  isForMine: !!authentication.get('user').salesSessionUserId,
});

const mapDispatchToProps = {
  dispatchGetTicketsV2: getTicketsV2,
  dispatchClearTickets: clearTickets,
};

Tickets.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  tickets: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetTicketsV2: PropTypes.func.isRequired,
  dispatchClearTickets: PropTypes.func.isRequired,
};

Tickets.defaultProps = {
  tickets: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tickets);
